import { combineReducers } from 'redux';
import { simpleReducer } from '@mgc/map-client-shared/lib/ReduxTools';
import actions from '../actions';

function _updateModalVisibility(state, modalName, visible) {
    return Object.assign({}, state, { [modalName]: visible });
}

export default combineReducers({
    //modals: (state = { transaction: true }, action) => {
    modals: (state = {}, action) => {
        switch (action.type) {
            case actions.OPEN_MODAL:
                return _updateModalVisibility(
                    state,
                    action.payload.modalName,
                    true
                );

            case actions.CLOSE_MODAL:
                return _updateModalVisibility(
                    state,
                    action.payload.modalName,
                    false
                );

            default:
                return state;
        }
    },

    appMounted: simpleReducer(false, { APP_MOUNTED: true }),

    accountModalPane: simpleReducer('profile', {
        SWITCH_ACCOUNT_MODAL_VIEW: (a) => a.payload.pane,
    }),
});



// WEBPACK FOOTER //
// ./app/reducers/ui.js